/* eslint-disable comma-dangle */
import React, { useEffect } from "react";
import { render } from "react-dom";
import { Provider, useDispatch } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { PersistGate } from "redux-persist/lib/integration/react";
import { QueryParamProvider } from "use-query-params";
import { Route } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faGhost } from "@fortawesome/free-solid-svg-icons";
import TagManager from "react-gtm-module";
import { renderRoutes } from "react-router-config";
import appRouters from "routes";
import Store, { history, persistor } from "store";
import Impersonate from "themes/cashrent/components/security/Impersonate";

import * as serviceWorker from "./serviceWorker";
import project from "../package.json";
import AgentConfirmation from "./components/user/AgentConfirmation";
import env from "environment";
import TenantActions from "./reducers/TenantRedux";
import ChangeGlobalStyles from "./hooks/useChangeGlobalStyles";
import { ThemeProvider } from "providers/ThemeProvider";
import AuthActions from "reducers/AuthRedux";

library.add(faGhost);

const tagManagerArgs = {
  gtmId: "GTM-P925FKJ",
  dataLayerName: "PageDataLayer",
};

TagManager.initialize(tagManagerArgs);

window.rootAppContainer = document.getElementById("root");

const FirebaseLayer = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AuthActions.restoreSession());
    const script = document.createElement("script");

    script.src = `https://maps.googleapis.com/maps/api/js?v=3.47&key=${env.REACT_APP_GMAP_KEY}&libraries=places&language=en`;
    script.defer = true;

    document.body.appendChild(script);
    dispatch(TenantActions.fetchCurrentTenant());
  }, []);

  return <div>{props.children}</div>;
};

// eslint-disable-next-line no-console
console.log(
  `%c CashRent v${project.version} Running`,
  "color:white;background-color:#fbb943;padding:2px 6px 4px 0;border-radius:4px;"
);

render(
  <Provider store={Store}>
     <ThemeProvider>
        <PersistGate persistor={persistor}>
          <FirebaseLayer>
            <ConnectedRouter history={history}>
              <QueryParamProvider ReactRouterRoute={Route}>
              <Impersonate />
              <AgentConfirmation />
              <ChangeGlobalStyles>
                {renderRoutes(appRouters)}
              </ChangeGlobalStyles>
              </QueryParamProvider>
            </ConnectedRouter>
          </FirebaseLayer>
        </PersistGate>
    </ThemeProvider>
  </Provider>,
  window.rootAppContainer
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
